import { motion } from 'framer-motion';
import { fadeUp, viewportOnce } from './Animations';
import { program } from '@/lib/program-data';
import iitc from "@/assets/iitc.jpg"

export default function ProgramOverview() {
  return (
    <section id="program" className="section-padding bg-edept-light-gray/40">
      <div className="container-content grid gap-12 lg:grid-cols-2 lg:items-center">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={fadeUp}
          className="relative aspect-[4/3] overflow-hidden rounded-3xl shadow-card-lg"
        >
          {/* Placeholder — TODO: replace with brochure campus imagery (Mahindra University / Illinois Tech). */}
          <img
            src={iitc}
            alt="IITC"
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={viewportOnce} variants={fadeUp}>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-edept-orange">
            Program overview
          </p>
          <h2 className="mt-3 text-3xl text-edept-dark sm:text-4xl">
            A joint degree global pathway
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            This M.A.S. in Data Science is delivered by edept alongside Mahindra
            University and Illinois Tech. You
            begin with {program.structure[0].duration} of foundational and
            applied coursework at Mahindra University, then transition to the
            on-campus phase at Illinois Tech for advanced coursework and your
            capstone project—graduating with a single, STEM-designated U.S.
            degree.
          </p>

          <div className="mt-8 rounded-2xl border border-edept-light-blue bg-white p-6 shadow-card">
            <h3 className="text-lg">Eligibility</h3>
            <ul className="mt-4 space-y-3 text-base text-slate-600">
              {program.admissions.eligibility.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span
                    className="mt-2 h-2 w-2 shrink-0 rounded-full bg-edept-orange"
                    aria-hidden="true"
                  />
                  <span className="leading-7">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
